import { clsx } from 'clsx'
import { LoadBar } from './LoadBar'

const FLOAT_FRAMES = [
  { img: '/teaser-lips.jpg', rotate: '-6deg', glow: 'shadow-neon-pink', pos: 'left-[8%] top-[12%]' },
  { img: '/assets/goongallery-promo.jpg', rotate: '8deg', glow: 'shadow-neon-violet', pos: 'right-[6%] top-[8%]' },
  { img: '/assets/grok-9cd0c44e-7b9e-42b1-9866-366d7eafdd7c.jpg', rotate: '-4deg', glow: 'shadow-neon-cyan', pos: 'left-[14%] bottom-[18%]' },
  { img: '/assets/grok-c1c3fd79-de5a-4b2c-8e0c-1f1710c1f67b.jpg', rotate: '5deg', glow: 'shadow-neon-pink', pos: 'right-[10%] bottom-[14%]' },
]

/** Snazzy pre-load gallery preview — neon burst background + floating frames
 *  while Bluesky media is still fetching. Matches promo ref energy. */
export function GalleryPreview({
  modeLabel,
  tags,
  sexuality,
  fraction,
  count,
  note,
  onCancel,
  className,
}: {
  modeLabel: string
  tags: string[]
  sexuality?: string | null
  fraction: number
  count: number
  note?: string
  onCancel?: () => void
  className?: string
}) {
  const pct = Math.round(fraction * 100)

  return (
    <main className={clsx('preview-stage relative min-h-[78vh] overflow-hidden px-4 py-8', className)}>
      {/* Radial speed lines */}
      <div className="preview-speedlines pointer-events-none absolute inset-0" aria-hidden />
      <div className="preview-burst pointer-events-none absolute inset-0" aria-hidden />

      {/* Floating tilted frames from promo ref */}
      {FLOAT_FRAMES.map((f, i) => (
        <div
          key={i}
          className={clsx(
            'preview-frame pointer-events-none absolute hidden h-28 w-36 overflow-hidden rounded-lg border-2 border-pow/50 sm:block md:h-36 md:w-44',
            f.glow,
            f.pos,
          )}
          style={{ transform: `rotate(${f.rotate})`, animationDelay: `${i * 0.35}s` }}
        >
          <img src={f.img} alt="" className="h-full w-full object-cover opacity-80" />
          <div className="absolute inset-0 bg-gradient-to-br from-pow/20 via-transparent to-boom/30" />
        </div>
      ))}

      <div className="relative z-10 mx-auto max-w-2xl text-center">
        <p className="text-[10px] uppercase tracking-[4px] text-kapow/80">{modeLabel}</p>
        <h2 className="goon-title mt-2 text-4xl sm:text-5xl">LOADING GALLERY…</h2>
        <p className="mt-2 text-sm text-[#f3c6ff]">Pulling NSFW feed through Bluesky</p>

        {sexuality ? (
          <div className="mt-5">
            <p className="mb-2 text-[10px] font-bold uppercase tracking-[3px] text-kapow">SEXUALITY</p>
            <span className="inline-block rounded-full border border-kapow/70 bg-kapow/15 px-4 py-1 font-comic text-sm tracking-wide text-kapow shadow-neon-cyan">
              {sexuality}
            </span>
          </div>
        ) : null}

        {/* NSFW tags up front */}
        {tags.length > 0 ? (
          <div className="mt-5">
            <p className="mb-2 text-[10px] font-bold uppercase tracking-[3px] text-pow">NSFW TAGS</p>
            <div className="flex flex-wrap justify-center gap-2">
              {tags.map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-pow/70 bg-pow/15 px-3 py-1 font-comic text-sm uppercase tracking-wide text-pow shadow-neon-pink animate-pulse-neon"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        ) : null}

        <div className="mx-auto mt-8 max-w-md rounded-2xl border border-edge/80 bg-ink/70 p-5 backdrop-blur-md shadow-cyber">
          <LoadBar fraction={fraction} count={count} label="FEED PREVIEW" />
          {note ? <p className="mt-2 animate-pulse-neon text-xs font-bold text-zap">{note}</p> : null}
          <p className="mt-2 text-xs text-muted">
            {pct < 100 ? 'Building mosaic… gradient sweep on reveal' : 'Popping tiles…'}
          </p>
        </div>

        {onCancel ? (
          <button
            onClick={onCancel}
            className="mt-6 text-xs uppercase tracking-widest text-muted underline transition hover:text-kapow"
          >
            Cancel
          </button>
        ) : null}
      </div>
    </main>
  )
}